import React from "react"

import PageBase from "components/Common/PageBase"
import FullSpinner from "components/Common/FullSpinner"

import useAvailabilityForm from "common/availability/hooks/useAvailabilityForm"
import AvailabilityFilters from "common/availability/components/AvailabilityFilters"
import ProductTabs from "common/availability/components/ProductTabs"
import AvailabilityForm from "common/availability/components/AvailabilityForm"
import AvailabilityList from "common/availability/components/AvailabilityList"

import useProviderAvailability from "./useProviderAvailability"
import AvailabilityCountdown from "./components/AvailabilityCountdown"
import { BREADCRUMB_LIST } from "./static"

import "common/availability/availability.css"

const ProviderAvailabilityContainer = () => {
  const { state, events } = useProviderAvailability()

  // Formulario de alta. Se reinicia al cambiar de sucursal (regions) y, tras
  // un alta correcta, de forma explícita.
  const form = useAvailabilityForm(null, state.regions)

  const onGuardar = async () => {
    if (!state.product || !state.farmId || !state.date) return
    const mensaje = form.validar()
    if (mensaje) {
      form.setError(mensaje)
      return
    }
    const ok = await events.onCreate(
      form.construirRegistro({ farmId: state.farmId, product: state.product })
    )
    if (ok) form.events.reset()
  }

  const puedeAlta = !!(state.product && state.farmId && state.date)

  let claseGuardar = "av-btn-save"
  if (state.isSaving) claseGuardar += " is-saving"
  else if (state.isSaved) claseGuardar += " is-saved"

  let textoGuardar = "Guardar"
  if (state.isSaving) textoGuardar = "Guardando…"
  else if (state.isSaved) textoGuardar = "✓ Guardado"

  return (
    <>
      {state.isLoading && <FullSpinner />}

      <PageBase
        titleMeta="Alta de Disponibilidad"
        titleBread="Alta de Disponibilidad"
        itemsBread={BREADCRUMB_LIST}
      >
        <div className="av-page mt-3">
          <div className="av-head av-anim">
            <div>
              <h1>Alta de Disponibilidad</h1>
              <p>
                Carga tu disponibilidad diaria: pesos, calificaciones, camiones y
                precios por zona.
              </p>
            </div>
            <div className="av-head-actions">
              <AvailabilityCountdown
                secondsLeft={state.secondsLeft}
                isExpired={state.isExpired}
                onExpire={events.onExpire}
              />
              <button
                type="button"
                className={claseGuardar}
                disabled={!puedeAlta || state.isSaving || state.isExpired}
                onClick={onGuardar}
              >
                {textoGuardar}
              </button>
            </div>
          </div>

          {state.isExpired && (
            <div className="av-notice av-anim">
              Fuera de tiempo para subir productos. La ventana de captura de hoy
              ya cerró: puedes consultar lo registrado, pero no dar de alta ni
              editar.
            </div>
          )}

          <AvailabilityFilters
            dates={state.dates}
            date={state.date}
            farms={state.farms}
            farmId={state.farmId}
            onChangeDate={events.onChangeDate}
            onChangeFarm={events.onChangeFarm}
          />

          {!state.isLoading && state.products.length === 0 && (
            <div className="av-empty">
              {state.farms.length === 0
                ? "No tienes sucursales registradas."
                : "No hay productos asignados a tu empresa."}
            </div>
          )}

          {state.product && (
            <>
              <ProductTabs
                products={state.products}
                tabActive={state.tabActive}
                onChangeTab={events.onChangeTab}
              >
                <div className="av-section-title">
                  <i />
                  <span>
                    {state.isExpired
                      ? `Captura cerrada — ${state.product.name}`
                      : `Nueva disponibilidad — ${state.product.name}`}
                  </span>
                </div>

                {state.isExpired ? (
                  <div className="av-empty">
                    La captura está cerrada por hoy.
                  </div>
                ) : (
                  <AvailabilityForm
                    form={form}
                    regions={state.regions}
                    farm={state.farm}
                    onSaveZones={events.onSaveZones}
                  />
                )}
              </ProductTabs>

              <AvailabilityList
                registradas={state.registradas}
                regions={state.regions}
                farm={state.farm}
                farmId={state.farmId}
                product={state.product}
                expanded={state.expanded}
                editing={state.editing}
                isSaving={state.isSaving}
                canEdit={!state.isExpired}
                onToggleExpanded={events.onToggleExpanded}
                onStartEdit={events.onStartEdit}
                onCancelEdit={events.onCancelEdit}
                onUpdate={events.onUpdate}
                onSaveZones={events.onSaveZones}
              />
            </>
          )}
        </div>
      </PageBase>
    </>
  )
}

export default ProviderAvailabilityContainer
